import SocialHandle from "./SocialHandle";

export default function SocialHandles() {
  const socialMediaHandles = [
      {link: 'https://x.com/SuitableShelte1', title: 'X', fa: 'fab fa-twitter'},
      {link: 'https://web.facebook.com/profile.php?id=100063708396611', title: 'Facebook', fa: 'fab fa-facebook-f'},
      {link: 'https://www.youtube.com/@suitableshelters5321', title: 'Youtube', fa: 'fab fa-youtube'},
      {link: 'https://www.linkedin.com/company/suitable-shelters-limited/', title: 'LinkedIn', fa: 'fab fa-linkedin-in'},
      {link: 'https://www.instagram.com/suitablesheltersltd/', title: 'Instagram', fa: 'fab fa-instagram'},
      {link: 'https://www.tiktok.com/@suitable.shelters', title: 'Tiktok', fa: 'fas fa-music'},
      {link: 'https://wa.me/message/IFRTZLZ5WFCJO1', title: 'Whatsapp', fa: 'fab fa-whatsapp'},
  ]
  return (          
          <div className="container py-5">          
              <div className="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "600px"}}>
                  <h1 className="mb-3">Follow Us on Social Media</h1>                   
              </div>            
              <div className="d-flex text-center row m-0">
                {
                    socialMediaHandles.map((media, i)=> <SocialHandle key={i} media={media} />)
                }
              </div>   
          </div>
  );
}